import React from 'react';
import TwilioChat from './TwilioChat';

const Chat: React.FC<{ mParam?: string | null }> = ({ mParam }) => {
  return <TwilioChat mParam={mParam} />;
};

export default Chat;
